import Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import HighchartsMore from "highcharts/highcharts-more";
import graphTheme from "../../graphTheme";

export type TWaterFallModel = {
    name: string;
    y: number;
    color?: string;
    borderColor?: string;
    enableMouseTracking?: boolean;
    showInLegend?: boolean;
    dataLabels?: { enabled?: boolean }
}

type THighchartWaterfallProps = {
    data: TWaterFallModel[]
    name: string
}

const HighchartWaterfall: React.FC<THighchartWaterfallProps> = ({ name, data }) => {
    HighchartsMore(Highcharts);
    
    const options: Highcharts.Options = {
    chart: {
        type: "waterfall",
        height: 450,
        width: null
    },
    credits: {
        enabled: false
    },
    title: {
        text: name,
    },
    xAxis: {
        type: "category",

    },
    yAxis: {
        title: {
            text: "%",
        },
    },
    legend: {
        enabled: false,
    },
    tooltip: {
        pointFormat: "<b>${point.y:,.2f}</b> %",
    },
    series: [
        {
        type: "waterfall",
        name: "Flujo financiero",
        upColor: Highcharts.getOptions().colors?.[6],
        color: Highcharts.getOptions().colors?.[3],
        data: data,
        dataLabels: {
            enabled: true,
            format: "{y:.2f}%",
        },
        pointPadding: 0,
        },
    ],
    };

    return (
        <HighchartsReact highcharts={Highcharts} options={options} inmutable={false} />
  );

}

export default HighchartWaterfall;